// Global navigation interceptor shared between router and RouterLink
let globalNavigationInterceptor: (() => boolean | Promise<boolean>) | null = null;

export function setNavigationInterceptor(interceptor: (() => boolean | Promise<boolean>) | null) {
  globalNavigationInterceptor = interceptor;
}

export function getNavigationInterceptor() {
  return globalNavigationInterceptor;
}